
const appMetrics = {
  // GENERAL
  PRIMARY_COLOR: '#2aabe2',
  SECUNDARY_COLOR: '#ba3d7f',
  LIGHT_COLOR: 'rgb(239, 227, 239)',
};

export default appMetrics;
